var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousels"},[_c('VueSlickCarousel',_vm._b({attrs:{"responsive":_vm.responsive}},'VueSlickCarousel',_vm.settings,false),[_vm._l((_vm.setcoins),function(item,index){return _c('div',{key:_vm.state.type,staticClass:"box"},[_c('div',{staticClass:"coinsName"},[_c('div',{staticClass:"coin"},[_c('img',{attrs:{"src":require('../../assets/coins/'+_vm.$coin2Snake[item.sourceCoinSymbol]+'.svg'),"alt":""}}),_c('div',{staticClass:"name-coin"},[_c('span',[_vm._v(_vm._s(_vm.$coinLabel[item.sourceCoinSymbol]))]),_c('small',[_vm._v(_vm._s(_vm.$coinsUnit[item.sourceCoinSymbol.toUpperCase()]))])])]),_c('div',{staticClass:"last-price"},[_c('span',{staticClass:"number",class:{'red':item.price24hrChangePercent < 0 , 'green':item.price24hrChangePercent >= 0}},[_vm._v(_vm._s(//  parseFloat(item.price24hrChangePercent).toPrecision(3) 
               
               _vm.$toPrecision(item.price24hrChangePercent,3))+"%\n\n\n\n             ")]),_c('small',[_vm._v("24h")])])]),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.$toLocal(item.price, _vm.$decimal['TOMAN']) + ' ' + 'تومان'))]),_c('div',{staticClass:"chart"},[_c('TrendChart',{attrs:{"datasets":[
  {
    data: [10, 50, 20, 100, 40, 60, 80],
    smooth: true,
    fill: true,
    className:'curveBlue'
  }
],"grid":{
   verticalLines: true,
   horizontalLines: true
},"min":0}}),(item.lastChange < 0)?_c('TrendChart',{attrs:{"datasets":[
  {
    data: [10, 50, 20, 100, 40, 60, 80],
    smooth: true,
    fill: true,
     className:'curveRed'
  }
],"grid":{
   verticalLines: true,
   horizontalLines: true
},"min":0}}):_vm._e()],1)])})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }